import { Modal } from "../modal";

document.querySelectorAll('[data-modal-open]').forEach(button => {
    const modal = new Modal(button, button.getAttribute('data-modal-open'), button.getAttribute('href'));
    button.addEventListener('click', (e) => {
        e.preventDefault();
        modal.open();
    });
});